exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-481d9aab] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.doc-message[data-v-481d9aab] {\n  width: 534px;\n  font-size: 14px;\n  line-height: 130%;\n  color: #1b1e22;\n}\n.doc-list-container[data-v-481d9aab] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 32px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n", ""]);

// exports
